import React from 'react'

import { NewUserPage } from '.'
import ChallengePage from './ChallengePage'
import { ProfDashboard, ProfStudents } from '../components'

import { InternalContent } from './styles'

const ProfessorsPage = ({ part }: { part: string }) => {
  return (
    <InternalContent style={{ overflowY: 'scroll' }}>
      {part === 'dashboard' ? (
        <ProfDashboard />
      ) : part === 'admin-new-user' ? (
        // <AdminNewUser />
        <NewUserPage />
      ) : part === 'prof-challenge' ? (
        <ChallengePage />
      ) : (
        <ProfStudents part={part} />
      )}
    </InternalContent>
  )
}

export default ProfessorsPage
